import { api } from './client'

// Thin wrapper around the /api/v1/push surface. The browser-side
// subscribe / unsubscribe / permission flow lives in
// services/pushNotifications.js — this module is just the bare HTTP
// calls so other surfaces (Profile toggles, etc.) can read status
// without pulling in the subscribe-flow plumbing.
export const pushApi = {
  status: (token) => api.get('/push/status', token),
  vapidKey: () => api.get('/push/vapid-key'),
  // Per-user reminder times — GET hydrates the Profile editor, PUT
  // replaces the whole record (server validates timezone). Times on the
  // wire are ISO-style HH:MM:SS strings; the server stores Postgres TIME.
  getReminders: (token) => api.get('/push/reminders', token),
  updateReminders: (prefs, token) => api.put('/push/reminders', prefs, token),
}
